import React from 'react';

const FirstTimeGuidance = ({ 
  showFirstTimeHelp, 
  setShowFirstTimeHelp, 
  hasProcessedResults,
  providerName = 'Flickr'
}) => {
  if (!showFirstTimeHelp || !hasProcessedResults) return null;

  return (
    <div className="mb-6 bg-blue-50 border border-blue-200 rounded-xl p-6">
      <div className="flex items-start space-x-4">
        <div className="flex-shrink-0">
          <div className="w-10 h-10 bg-blue-500 rounded-full flex items-center justify-center">
            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h1m0-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
        </div>
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-blue-900 mb-2">How to Review Your Results</h3>
          <ul className="text-sm text-blue-800 space-y-1 mb-4">
            <li>• <strong>Quick approval:</strong> Use "Apply All to {providerName}" above if the results look good</li>
            <li>• <strong>Individual review:</strong> Click any photo card below to edit titles, descriptions, or tags</li>
            <li>• <strong>Batch selection:</strong> Check boxes to apply multiple photos at once</li>
          </ul>
          <button
            onClick={() => setShowFirstTimeHelp(false)}
            className="text-sm text-blue-600 hover:text-blue-800 font-medium"
          >
            Got it, hide this help →
          </button>
        </div>
      </div>
    </div>
  );
};

export default FirstTimeGuidance;
